import React from "react";
import { Link } from "react-router-dom";
import { Award, BarChart3, Shield, InfoIcon, ArrowRight } from "lucide-react";

const GradeMyRate: React.FC = () => {
  //   const features = [
  //     {
  //       icon: Award,
  //       title: "Your Information Stays Private",
  //       description:
  //         "You don't need to give us your phone number or email. This is a no-spam zone.",
  //     },
  //     {
  //       icon: BarChart3,
  //       title: "Compare Against Market Rates",
  //       description:
  //         "Compare your quote against the national average and other local lenders to know you are getting a good deal.",
  //     },
  //     {
  //       icon: Shield,
  //       title: "Actionable Recommendations",
  //       description:
  //         "You'll know if you should stick with your current lender or shop around for a better deal.",
  //     },
  //   ];

  return (
    <div className="py-4 md:py-12 px-4">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4">
            Grade Your Mortgage Rate Quote
          </h1>
          <p className="text-xl text-gray-600">
            Get a second opinion on your quote, no hassle required.
          </p>
        </div>

        {/* How It Works Section */}
        <div className="bg-primary-light/5 border border-primary-light/20 rounded-lg p-6 mb-10 max-w-3xl mx-auto">
          <div className="flex">
            <div>
              <h3 className="font-medium text-gray-900 mb-2">
                How Quote Grading Works:
              </h3>
              <ol className="list-decimal list-inside space-y-4 text-gray-700">
                <li>
                  <span className="font-medium">
                    Enter Your Current Quote Details
                  </span>
                  <p className="ml-6 mt-1">
                    Share quote details from your broker (if applicable) and
                    basic loan information
                  </p>
                </li>
                <li>
                  <span className="font-medium">Expert Analysis</span>
                  <p className="ml-6 mt-1">
                    Our mortgage experts review your quote and compare it to
                    current market rates.
                  </p>
                </li>
                <li>
                  <span className="font-medium">
                    Receive Your Grade & Analysis
                  </span>
                  <p className="ml-6 mt-1">
                    Get a letter grade (A-F), recommendations, and alternate
                    quotes within 24 hours.
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </div>

        {/* Benefits Section
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12 max-w-3xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-sm border border-gray-100"
            >
              <div className="w-12 h-12 bg-primary-light/10 rounded-full flex items-center justify-center mb-4">
                <feature.icon size={24} className="text-primary" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div> */}

        {/* CTA Section */}
        <div className="text-center max-w-3xl mx-auto mb-8">
          <Link
            to="/check-my-rate"
            className="btn-primary inline-flex items-center space-x-2 text-lg"
          >
            <span>Get Started Now</span>
            <ArrowRight size={18} />
          </Link>
        </div>

        {/* Example Report Link */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <Link
            to="/example-results"
            className="text-primary hover:text-primary-dark inline-flex items-center space-x-2"
          >
            <span>See an example analysis</span>
            <ArrowRight size={16} />
          </Link>
        </div>
        {/* FAQ Section */}
        <div className="mt-16 max-w-3xl mx-auto">
          <h2 className="text-2xl font-heading font-semibold text-gray-800 mb-6 text-center">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            {/* Ad da FAQ for "Who is this for?" */}

            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <details className="group">
                {/* Add FAQs for will I get spam, and what do the letter grades mean? */}

                <summary className="flex justify-between items-center p-4 cursor-pointer bg-white hover:bg-gray-50">
                  <h3 className="text-lg font-medium text-gray-800">
                    Who is this for?
                  </h3>
                  <span className="transition group-open:rotate-180">
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M6 9l6 6 6-6"
                      ></path>
                    </svg>
                  </span>
                </summary>

                <div className="p-4 pt-0 text-gray-700">
                  <p>
                    If you're buying a home and want to save money on your
                    mortgage—whether or not you already have a lender—this is
                    for you.
                  </p>

                  <p className="mt-4">We help people who:</p>
                  <ul className="list-disc list-inside mt-2 space-y-1">
                    <li>Are planning to purchase or refinance a home soon</li>
                    <li>
                      Don't have a lender and want to see current market rates
                    </li>
                    <li>
                      Have a quote and want to compare it to other local lenders
                    </li>
                    <li>Want to see if they can beat their lender's quote</li>
                    <li>Are ready to get pre-approved</li>
                  </ul>

                  <p className="mt-4">
                    Refinancing? Try our new{" "}
                    <Link className="text-primary" to="/should-i-refinance">
                      Refi Buddy
                    </Link>{" "}
                    tool.
                  </p>
                </div>
              </details>
            </div>

            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <details className="group">
                {/* Add FAQs for will I get spam, and what do the letter grades mean? */}

                <summary className="flex justify-between items-center p-4 cursor-pointer bg-white hover:bg-gray-50">
                  <h3 className="text-lg font-medium text-gray-800">
                    Is my information really anonymous?
                  </h3>
                  <span className="transition group-open:rotate-180">
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M6 9l6 6 6-6"
                      ></path>
                    </svg>
                  </span>
                </summary>

                <div className="p-4 pt-0 text-gray-700">
                  <p>
                    Yes! We only ask for basic loan information that is required
                    to give an accurate quote. None of this information can
                    identify you personally. You can choose to give us your
                    email so we can let you know when your analysis is ready,
                    but you don't have to.
                  </p>
                </div>
              </details>
            </div>

            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <details className="group">
                <summary className="flex justify-between items-center p-4 cursor-pointer bg-white hover:bg-gray-50">
                  <h3 className="text-lg font-medium text-gray-800">
                    What does the quote comparison include?
                  </h3>
                  <span className="transition group-open:rotate-180">
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M6 9l6 6 6-6"
                      ></path>
                    </svg>
                  </span>
                </summary>
                <div className="p-4 pt-0 text-gray-700">
                  <p>Your quote comparison will include:</p>
                  <ul className="list-disc list-inside mt-2 space-y-1">
                    <li>A letter grade for your current quote</li>
                    <li>Comparison to national average rates</li>
                    <li>Rate quote(s) from other local lending partners</li>
                    <li>Pros and cons of your current quote</li>
                    <li>Recommendations for improvement (if applicable)</li>
                  </ul>
                </div>
              </details>
            </div>

            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <details className="group">
                <summary className="flex justify-between items-center p-4 cursor-pointer bg-white hover:bg-gray-50">
                  <h3 className="text-lg font-medium text-gray-800">
                    What if I don't have a quote from another lender?
                  </h3>
                  <span className="transition group-open:rotate-180">
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M6 9l6 6 6-6"
                      ></path>
                    </svg>
                  </span>
                </summary>
                <div className="p-4 pt-0 text-gray-700">
                  <p>
                    We will compare local rates from local lenders and provide
                    you:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1">
                    <li>National average rates</li>
                    <li>Rate quote(s) from other local lending partners</li>
                    <li>Recommendations for improvement (if applicable)</li>
                  </ul>
                </div>
              </details>
            </div>

            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <details className="group">
                <summary className="flex justify-between items-center p-4 cursor-pointer bg-white hover:bg-gray-50">
                  <h3 className="text-lg font-medium text-gray-800">
                    How long does it take to get my grade?
                  </h3>
                  <span className="transition group-open:rotate-180">
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M6 9l6 6 6-6"
                      ></path>
                    </svg>
                  </span>
                </summary>
                <div className="p-4 pt-0 text-gray-700">
                  <p>
                    The process of submitting your quote takes less than 2
                    minutes, and you will receive your quote grade and analysis
                    in less than a day. We want to make sure we provide helpful
                    service and actionable feedback, so we haven't automated the
                    process. Real humans will review your situation and give
                    expert advice.
                  </p>
                </div>
              </details>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GradeMyRate;
